import React from 'react';
import {useTranslation} from 'react-i18next';
import {SpecificationViewData} from '../../../models/specificationViewer';

type SectionSafetyProps = {
    spec: SpecificationViewData;
}

const SectionSafety: React.FC<SectionSafetyProps> = ({spec}) => {
    const {t} = useTranslation();

    return (
        <div>
            {spec.protectionNotRequired &&
                <div className="bool-row">
                    <div className="bool-indicator yes">&#10003;</div>
                    <div className="bool-label">{t('specificationViewer.protectionNotRequired')}</div>
                </div>
            }

            {spec.securityMeasures.length > 0 && spec.securityMeasures.map(measure => (
                <div className="security-measure" key={measure.id}>
                    {measure.icon &&
                        <img
                            className="measure-icon"
                            src={process.env.REACT_APP_API_ENDPOINT + 'file/uploads/' + measure.icon.path}
                            alt={measure.name}
                            loading="lazy"
                        />
                    }
                    <div className="measure-name">{measure.name}</div>
                </div>
            ))}

            {spec.protectionOther &&
                <div className="info-row">
                    <div className="info-label">{t('specificationViewer.protectionOther')}</div>
                    <div className="info-value">{spec.protectionOther}</div>
                </div>
            }

            <div className="bool-row">
                <div className={`bool-indicator ${spec.chemicals ? 'yes' : 'no'}`}>
                    {spec.chemicals ? '\u2713' : '\u2717'}
                </div>
                <div className="bool-label">{t('specificationViewer.chemicals')}</div>
            </div>

            <div className="bool-row">
                <div className={`bool-indicator ${spec.electrostaticProtection ? 'yes' : 'no'}`}>
                    {spec.electrostaticProtection ? '\u2713' : '\u2717'}
                </div>
                <div className="bool-label">{t('specificationViewer.electrostaticProtection')}</div>
            </div>

            <div className="bool-row">
                <div className={`bool-indicator ${spec.environmentalImpact ? 'yes' : 'no'}`}>
                    {spec.environmentalImpact ? '\u2713' : '\u2717'}
                </div>
                <div>
                    <div className="bool-label">{t('specificationViewer.environmentalImpact')}</div>
                    {spec.environmentalImpact && spec.environmentalImpactAction &&
                        <div className="bool-comment">{spec.environmentalImpactAction}</div>
                    }
                </div>
            </div>
        </div>
    );
};

export default SectionSafety;
